import { render } from "./px-expand.vue?vue&type=template&id=007ba2e1&scoped=true&ts=true"
import script from "./px-expand.vue?vue&type=script&lang=ts"
export * from "./px-expand.vue?vue&type=script&lang=ts"

import "./px-expand.vue?vue&type=style&index=0&id=007ba2e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007ba2e1"]])

export default __exports__